import axios from "axios";
import {config} from "../config"

export const getSurveyData = async (userGuid: any, surveyGuid: any) => {
  const response = await axios.get(`${config.VANTAGE_API_URL}/api/Survey/SurveyActivity/${userGuid}/${surveyGuid}`);
  return response.data.resultModel;
};

export const submitSurvey = async (responses: any) => {
  const response = await axios.post(`${config.VANTAGE_API_URL}/api/Survey/SubmitUserResponses`, responses, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};
